import React from "react"
import ReactDOM from 'react-dom/client';
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"
import axios from "axios"
import { ToastContainer, toast } from 'react-toastify';

import store from "./store"

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken'); 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; 
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);



axios.interceptors.response.use(
  response => response,
   async error => {
    if (error.response?.status === 401 && error.response?.data?.message === "TokenExpired") {
      localStorage.clear();
      delete axios.defaults.headers.common['Authorization'];


      toast.warning('Your session has expired. Please login again.', {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
      });

      await new Promise(resolve => setTimeout(resolve, 2000));
      window.location.href = '/login';
      return Promise.resolve({ data: null });
    }
    return Promise.reject(error);
    
    
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
      <>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
      <ToastContainer />
  </>
    </Provider>
);

serviceWorker.unregister()
